
  export default {
    props: { video: { type: Object, required: true } }
  };
